export default {
  tagUpdated: 'Tag updated.',
  tagAdded: 'Tag added.',
  editTag: 'Edit tag',
  addTag: 'Add tag',
  tagDescription: 'A Bluetooth tag carried by a person or fixed to a tool.',
  macAddress: 'MAC address',
  macHint: 'Printed on the tag, e.g. AC:23:3F:12:34:56',
  label: 'Label',
  tagLabelPlaceholder: 'e.g. Tag 07',
  tagActive: 'Active. Detections from this tag are recorded',
  tagAssigned: 'Tag assigned.',
  assignTag: 'Assign tag',
  targetPerson: 'Person',
  targetAsset: 'Asset',
  employee: 'Employee',
  employeeHint: 'Tracks their presence at sites, no phone needed.',
  selectEmployee: 'Select an employee',
  assetHint: 'Logs where the tool was last seen.',
  selectAsset: 'Select an asset',
  assigning: 'Assigning…',
  assign: 'Assign',
  gatewayUpdated: 'Gateway updated.',
  gatewayAdded: 'Gateway added.',
  editGateway: 'Edit gateway',
  addGateway: 'Add gateway',
  gatewayDescription: 'A Bluetooth gateway that listens for tags at a site.',
  hardwareId: 'Hardware ID',
  hardwareIdHint: "The gateway's MAC address, from its label.",
  gatewayLabelPlaceholder: 'e.g. Site office gate',
  site: 'Site',
  siteHint: 'Detections only count for a site once the gateway is assigned to it.',
  unassigned: 'Unassigned',
  gatewayActive: 'Active. Detections from this gateway are recorded',
  beaconTag: 'Beacon tag',
  beaconTagHint: 'A Bluetooth tag lets {name} be tracked by site gateways, with or without a phone.',
  since: 'since {when}',
  tagUnassigned: 'Tag unassigned.',
  unassign: 'Unassign',
  unassignedTags: 'Unassigned tags',
  selectTag: 'Select a tag',
  noFreeTags: 'No free tags. Add one under Beacons',
}
